import type { RecentlyReleasedItem } from '../types'
import { RecentlyReleasedCard } from './RecentlyReleasedCard'
import SectionHeading from './SectionHeading'

interface RecentlyReleasedGridProps {
  items: RecentlyReleasedItem[]
}

const RecentlyReleasedGrid = ({ items }: RecentlyReleasedGridProps) => {
  return (
    <div className="flex flex-col gap-4">
      <SectionHeading>Recently released</SectionHeading>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {items.map((item, i) => (
          <RecentlyReleasedCard key={i} item={item} />
        ))}
      </div>
    </div>
  )
}

export default RecentlyReleasedGrid
